import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { OffersGrid } from "@/components/OffersGrid";
import { UsatoStrip } from "@/components/UsatoStrip";

/**
 * Sotto gli articoli del blog: le auto nuove (offerte del mese) e, separate, le usate SecondLife.
 */
export const AutoCorrelate = ({ testid = "auto-correlate" }) => (
  <div className="border-t border-xmove-ink/8 bg-xmove-cream/40" data-testid={testid}>
    <OffersGrid
      limit={3}
      title="Noleggio lungo termine auto nuova: le offerte del mese"
      subtitle="Canoni reali e aggiornati, con RCA, Kasko, manutenzione e assistenza H24 inclusi."
      testId={`${testid}-nuove`}
    />
    <div className="mx-auto -mt-8 max-w-7xl px-5 pb-6 lg:px-8">
      <Link to="/offerte/" className="inline-flex items-center gap-1.5 text-sm font-bold text-xmove-orange hover:underline" data-testid={`${testid}-nuove-link`}>
        Tutte le offerte su auto nuova <ArrowRight size={15} />
      </Link>
    </div>
    <UsatoStrip
      limit={3}
      titolo="Noleggio lungo termine usato: le auto SecondLife disponibili adesso"
      sottotitolo="Auto rientrate dal noleggio, con massimo 70/80.000 km e le stesse garanzie del lungo termine: risparmio fino al 40%."
      testid={`${testid}-usate`}
    />
  </div>
);
